
gsap.registerPlugin(ScrollTrigger)

const Inview = new function () {
    let elements = []
    
    this.init = () => {
        document.querySelectorAll('[data-inview]').forEach(element => {
            elements.push({
                el: element,
                // animation: element.dataset.inview
            })
        })
    
        elements.forEach(element => {            
            ScrollTrigger.create({
                trigger: element.el,
                // markers: true,
                // toggleClass: 'is-inview',
                scroller: document.querySelector('#ss-page'),
                onEnter() {
                    element.el.classList.add('is-inview');
                },
            })
        })
    }
    this.kill = () => {
        document.querySelectorAll('[data-inview]').forEach(element => {
            elements.push({
                el: element,
            })
        })
    
        elements.forEach(element => {     
            element.scrollTrigger.kill()
        })
    }

    
}

export default Inview